"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AnimalVets;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function AnimalVets(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.5 42.5"
  }, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".vets{fill:#0037FF;}"
    }
  }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    className: "vets",
    d: "M24,42.5h-5.3c-2.5,0-4.5-2-4.5-4.5V4.5c0-2.5,2-4.5,4.5-4.5H24c2.5,0,4.5,2,4.5,4.5V38 C28.6,40.5,26.5,42.5,24,42.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "vets",
    d: "M42.5,18.6v5.3c0,2.5-2,4.5-4.5,4.5H4.5c-2.5,0-4.5-2-4.5-4.5v-5.3c0-2.5,2-4.5,4.5-4.5H38 C40.5,14.1,42.5,16.1,42.5,18.6z"
  })));
}